import TopBar from "@/components/TopBar";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import WhyChooseUs from "@/components/WhyChooseUs";
import ReviewWidget from "@/components/ReviewWidget";
import ServiceAreas from "@/components/ServiceAreas";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { faqs } from "@/lib/faq-data";

const Index = () => {
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="MGL Cleaning Solutions | House & Office Cleaning in Germantown, TN"
        description="Germantown, TN cleaning company offering deep, regular, move-in/out, one-time & office cleaning in Collierville, Cordova, Bartlett & Memphis. Free estimates."
        path="/"
        jsonLd={faqJsonLd}
      />
      <TopBar />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <WhyChooseUs />
        <ReviewWidget />
        <ServiceAreas />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
